const actionType = {
    DISABLE_LOADER: 'DISABLE_LOADER',
    ENABLE_LOADER: 'ENABLE_LOADER',
    VALIDATION_MESSAGE: 'VALIDATION_MESSAGE',
};
export default actionType;
